import React, { useEffect, useRef, useState } from 'react'
import styles from './blog-create.module.scss'
import { ACTION, ROUTES } from 'consts'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CKEditor } from 'ckeditor4-react'
import parse from 'html-react-parser'

// antd
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Input, notification, Form, Select } from 'antd'

// apis
import { createBlog, updateBlog } from 'apis/blog'
import { getBranches } from 'apis/branch'

export default function BlogCreate() {
  const history = useHistory()
  const location = useLocation()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const [content, setContent] = useState('')
  const [branches, setBranches] = useState([])

  const _createOrUpdateBlog = async () => {
    try {
      await form.validateFields()

      if (!content) {
        notification.error({ message: 'Vui lòng nhập nội dung bài viết' })
        return
      }

      dispatch({ type: ACTION.LOADING, data: true })
      const formData = form.getFieldsValue()
      const body = {
        ...formData,
        subtitle: formData.subtitle || '',
        content: content,
      }
      console.log(body)
      let res
      if (location.state) {
        res = await updateBlog(location.state.blog_id, body)
      } else {
        res = await createBlog(body)
      }
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          history.push(ROUTES.BLOG)
          notification.success({
            message: `${location.state ? 'Cập nhật' : 'Tạo'} bài viết thành công`,
          })
        } else
          notification.error({
            message:
              res.data.message ||
              `${location.state ? 'Cập nhật' : 'Tạo'} bài viết thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${location.state ? 'Cập nhật' : 'Tạo'} bài viết thất bại, vui lòng thử lại`,
        })

      dispatch({ type: ACTION.LOADING, data: false })
    } catch (err) {
      console.log(err)
    }
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setBranches(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    _getBranches()
  }, [])

  useEffect(() => {
    if (location.state) {
      form.setFieldsValue({ ...location.state })
      setContent(location.state.content || '')
    }
  }, [])

  return (
    <div className={styles['body_blog']}>
      <div className={styles['body_blog_header']}>
        <div className={styles['body_blog_header_title']}>
          <ArrowLeftOutlined
            onClick={() => history.push(ROUTES.BLOG)}
            style={{ fontSize: '20px', paddingRight: '10px' }}
          />
          <span className={styles['body_blog_header_list_text']}>
            {location.state ? 'Cập nhật bài viết' : 'Tạo bài viết'}
          </span>
        </div>
        <Button onClick={_createOrUpdateBlog} style={{ width: '90px' }} type="primary">
          {location.state ? 'Cập nhật' : 'Tạo'}
        </Button>
      </div>
      <hr />
      <br />
      <div className={styles['body_blog_content']}>
        <Form layout="vertical" form={form} className={styles['body_blog_content_header']}>
          <Form.Item
            label="Tiêu đề"
            name="title"
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
          >
            <Input allowClear style={{ width: '50%' }} placeholder="Nhập tên bài viết" />
          </Form.Item>
          <Form.Item name="subtitle" label="Phụ đề">
            <Input allowClear style={{ width: '50%' }} placeholder="Nhập phụ đề" />
          </Form.Item>
          <Form.Item
            label="Chi nhánh"
            name="branch_id"
            rules={[{ required: true, message: 'Vui lòng nhập chi nhánh' }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              style={{ width: '50%' }}
              placeholder="Chọn chi nhánh"
              allowClear
            >
              {branches.map((branch, index) => (
                <Select.Option value={branch.branch_id} key={index}>
                  {branch.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <br />
          <div>
            <div>Nội dung bài viết</div>
            <CKEditor
              initData={location.state ? parse(location.state.content) : ''}
              onChange={(e) => setContent(e.editor.getData())}
            />
          </div>
        </Form>
      </div>
    </div>
  )
}
